import { getAppStore } from '~src/app/AppStore';
import { selectContentFromAppState } from '~src/app/selectors/ContentSelectors';
import { WebClientListResourceFetcher } from '~src/commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';

import { IResourceGovernanceEditSiteAction } from '../actions/ResourceGovernanceEditSiteAction';
import { IResourceGovernanceResetSiteToDefaultsAction } from '../actions/ResourceGovernanceResetSiteToDefaultAction';
import { GetResourceGovernanceSiteSettingsRequest, IGetResourceGovernanceSiteSettingsResult, IResourceGovernanceSiteSetting } from './ResourceGovernance';

export type ResourceGovernanceAllowedActions = Readonly<
  IResourceGovernanceEditSiteAction &
  IResourceGovernanceResetSiteToDefaultsAction
>;

export namespace ResourceGovernanceService {
  export function resultMapper(result: IGetResourceGovernanceSiteSettingsResult): IResourceGovernanceSiteSetting[] {
    return result.settings.map(s => ({
      ...s,
      id: s.siteId,
      contentType: 'resourceGovernanceSetting',
    }));
  }

  export function all(): ResourceQuery<IResourceGovernanceSiteSetting> {
    const fetcher = new WebClientListResourceFetcher(GetResourceGovernanceSiteSettingsRequest, resultMapper);
    return new ResourceQuery(fetcher);
  }

  export function actions(): Promise<ResourceGovernanceAllowedActions> {
    const items = selectContentFromAppState(getAppStore().getState()) as unknown as IResourceGovernanceSiteSetting[];
    const anyNonDefault = items.reduce((anyNonDefault, item) => anyNonDefault || !item.isDefault, false);
    return Promise.resolve({
      resetSiteResourceGovernanceSite: anyNonDefault,
      editResourceGovernanceSite: true,
    });
  }
}
